import { useContext } from 'react';
import { StatsigContext } from 'shared/providers/statsig/StatsigContext';

export const useStatsig = () => {
  const context = useContext(StatsigContext);
  if (!context) {
    throw new Error('useStatsig must be used within a CustomStatsigProvider');
  }
  return context;
};
